import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=448a5dcc"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=448a5dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports